import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../state/selectors";

import IdleModal from "./IdleModal";

const IdleDetector = ({ onLogout }) => {
  const [idleModalActive, setIdleModalActive] = useState(false);

  const isLoggedIn = useSelector(selectIsLoggedIn());
  const cognitoUser = useSelector((store) => store.auth.cognitoUser);

  let timeoutId = null;

  useEffect(() => {
    if (idleModalActive || !isLoggedIn || !cognitoUser) {
      return;
    }

    restartIdleTimeout();

    window.addEventListener("mousemove", onMouseMove);

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, [idleModalActive, isLoggedIn, cognitoUser]);

  useEffect(() => {
    if (idleModalActive && (!isLoggedIn || !cognitoUser)) {
      setIdleModalActive(false);
    }
  }, [idleModalActive, isLoggedIn, cognitoUser]);

  const onMouseMove = () => {
    restartIdleTimeout();
  };

  const restartIdleTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      setIdleModalActive(true);
    }, 1000 * 60 * 15); // 15 minutes
  };

  return <IdleModal active={idleModalActive} setActive={setIdleModalActive} onLogout={onLogout} />;
};

IdleDetector.propTypes = {
  onLogout: PropTypes.func.isRequired
};

export default IdleDetector;
